export default "__VITE_ASSET__C2IsC5y4__"